import { createGlobalStyle } from "styled-components";

import { TinyColor as Color } from "@ctrl/tinycolor";

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background-size: cover;

    &::selection {
      color: white;
      background-color: ${({ theme }) => theme.token.colorPrimaryActive};
    }
  }
  
  #root {
    height: 100%;
    scrollbar-gutter: stable;
  }

  body {
    background-color: #fff;
  }

  button {
    outline: none;
    border: none;
    border-style: none
  }

  input[type=number]::-webkit-inner-spin-button { 
    -webkit-appearance: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    -webkit-text-fill-color: text !important;
    transition: background-color 5000s ease-in-out 0s;
  }

  p {
    margin: 0;
  }

  #nprogress {
    .bar {
      background-color: ${({ theme }) => theme.token.colorPrimary};
    }

    .bar {
      box-shadow: ${({ theme }) =>
        `0 0 10px ${theme.token.colorPrimary}, 0 0 5px ${theme.token.colorPrimary}`};
    }
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .rc-virtual-list-scrollbar-thumb,
  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => new Color(theme.token.colorPrimary).toRgbString()} !important;
    border-radius: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-button {
    display: none;
  }
`;
